import React from 'react';

const ExtraActivitiesList = ({ activities }) => {
  return (
    <>
      {activities.map((activity, index) => (
        <p key={index}>{activity.name}: {activity.price}</p>
      ))}
    </>
  );
};

export default ExtraActivitiesList; 